import React from 'react';
import { Box, Alert } from './style';
import { Container } from 'reactstrap';

const BrowserSupportAlert = () => {
  const isIE = () => {
    // get the userAgent property of the window.navigator object
    const ua = window.navigator.userAgent;
    // IE 10 or older
    const msie = ua.indexOf('MSIE ');
    //IE 11
    const trident = ua.indexOf('Trident/');

    return msie > 0 || trident > 0;
  }

  const isSupportedBrowser = () => !isIE();

  return (
    <>
      {!isSupportedBrowser() && (
        <Box>
          <Container>
            <Alert>
              Our website has detected that you are using an outdated browser that will prevent you from accessing certain features. An update is not required, but is strongly recommended to improve your browsing experience. Please use Edge, Chrome or Firefox for a better user experience.
            </Alert>
          </Container>
        </Box>
      )}
    </>
  );
}

export default BrowserSupportAlert;
